import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Fill = forwardRef<SVGSVGElement, SvgIconProps>(function Fill(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path d="m2,19.14l6.494,0l3.607,4.94l3.61,-4.94l6.494,0c0.324,0 0.57,-0.25 0.57,-0.577l-0,-18c0,-0.32 -0.25,-0.577 -0.57,-0.577l-20.2,0c-0.324,0 -0.57,0.25 -0.57,0.577l0,18c0,0.32 0.25,0.577 0.576,0.577l-0,0zm7.227,-11.3l1.705,1.725l4.067,-4.09l1.754,1.798l-4.067,4.09l-1.778,1.774l-1.754,-1.798l-1.7,-1.725l1.778,-1.774z" />
    </SvgIcon>
  )
})

export default Fill
